import styles from "./sort.module.css";
const SortFilter = ({ heading, sortBy, setSortBy }) => {
  return (
    <div className={styles.sortControl}>
      <span className={styles.sortLabel}>{heading || ""}</span>
      <select
        value={sortBy}
        onChange={(e) => setSortBy(e.target.value)}
        className={styles.sortSelect}
      >
        <option value={"Relevance"}>Relevance</option>
        <option value={"Low to High"}>Low to High</option>
        <option value={"High to Low"}>High to Low</option>
        <option value={"Newest First"}>Newest First</option>
      </select>
    </div>
  );
};
export default SortFilter;